import React from 'react';
import { Input, Form, message, Modal } from 'antd';

export default (props) => {
    const [form] = Form.useForm();
    const [isOpen, setIsOpen] = React.useState(props.isOpen);

    React.useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);
    const onCancel = () => {
        setIsOpen(false);
        props?.onCancel();
    };
    const submit = async () => {
        const values = await form.validateFields();
        console.log('Success:', values);
        const response = await fetch("/api/account/update-password", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
        });

        const result = await response.json();

        if(result?.success) {
            message.success('修改成功');
            props?.onCancel();
            setTimeout(() => {
                window.location.href = '/logout';
            }, 800);
        }else{
            message.error(result.data);
        }
    };

    return (
        <Modal open={isOpen} onCancel={onCancel} onOk={submit}>
            <h2>修改密码</h2>
            <Form
                form={form}
                layout="vertical"
                name="update-password"
                initialValues={{
                    remember: true,
                }}
            >
                <Form.Item
                    label="旧密码"
                    name="oldPassword"
                    layout="vertical"
                    rules={[
                        {
                            required: true,
                            message: '请输入旧密码!',
                        },
                    ]}
                >
                    <Input.Password placeholder="请输入旧密码" />
                </Form.Item>

                <Form.Item
                    label="新密码"
                    layout="vertical"
                    name="newPassword"
                    rules={[
                        {
                            required: true,
                            message: '请输入新密码!',
                        },
                        // 正则校验
                        {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d).{8,20}$/,
                            message: '密码长度为8-20位，包含字母、数字！',
                        },
                    ]}
                >
                    <Input.Password placeholder="请输入新密码" />
                </Form.Item>

                <Form.Item
                    label="确认密码"
                    layout="vertical"
                    name="rePassword"
                    rules={[
                        {
                            required: true,
                            message: '请输入确认密码!',
                        },
                        {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d).{8,20}$/,
                            message: '密码长度为8-20位，包含字母、数字！',
                        },
                    ]}
                >
                    <Input.Password placeholder="请输入确认密码" />
                </Form.Item>
            </Form>
        </Modal>
    )
}